<template>
  <!-- 绑定信息 -->
  <div class="module-info">
    <!-- 表格 -->
    <DiluTable :list="getBindInfoByBikeCodeList" :tableConfig="tableConfig">
      <el-table-column
        prop="account"
        :label="$t('pages.equipment.text38')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bindType"
        :label="$t('pages.equipment.text39')"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.bindType == 0
              ? $t("pages.equipment.text40")
              : $t("pages.equipment.text41")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bindStatus"
        :label="
          $t('pages.equipment.text42') + '/' + $t('pages.equipment.text43')
        "
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.bindStatus == 0
              ? $t("pages.equipment.text42")
              : $t("pages.equipment.text43")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="unbindReason"
        :label="$t('pages.equipment.text44')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createdAt"
        :label="$t('omission.text75')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="unbindTime"
        :label="$t('omission.text76')"
        align="center"
      >
      </el-table-column>
    </DiluTable>
  </div>
</template>

<script>
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
export default {
  data() {
    return {
      tableConfig: {
        isTree: false,
        isTreeText: "id",
        isPage: false,
      },
    };
  },
  props: ["getBindInfoByBikeCodeList"],
  components: {
    DiluTable,
  },
};
</script>

<style scoped>
.module-info {
  padding: 20px 10px;
  box-sizing: border-box;
}
</style>